import React from 'react';
import {Button, Card, Descriptions, Divider, List} from 'antd';
import EntriesIterator from "../../components/EntriesIterator";
import {getActions} from "../../services/ActionsService";
import ActionsAdd from "./ActionsAdd";
import ActionsEdit from "./ActionsEdit";
import {CheckCircleOutlined, CloseCircleOutlined} from "@ant-design/icons";

class Actions extends EntriesIterator {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }
    }

    reloadPage = () => {
        this.onPage(this.state.page, this.state.filters);
        this.onClose();
    };

    onClose = () => {
        this.setState({key: new Date().getTime()});
    };

    processPaginatedRequest(page, rows, filters) {
        return getActions(this.props.client, page, rows, filters);
    }

    renderAdditionalColumns() {
        return null;
    }

    renderView() {
        return <div>
            <div className="action-separator">
                <ActionsAdd client={this.props.client}
                            action={{configuration: {}}} key={"add_" + this.state.key}
                            onSave={this.reloadPage} onClose={this.onClose}/>
            </div>

            <div className="cards-container">
                <List itemLayout="horizontal"
                      grid={{gutter: 16, xs: 1, lg: 3}}
                      dataSource={this.state.data}
                      renderItem={item => (
                          <List.Item key={item.id}>
                              <Card>
                                  <Card.Meta title={
                                      <div>
                                          {item.name}
                                          <div className="float-right">
                                              <ActionsEdit
                                                  action={JSON.parse(JSON.stringify(item))}
                                                  client={this.props.client}
                                                  key={"editForm" + item.id}
                                                  onSave={this.reloadPage} onDelete={this.reloadPage}
                                                  onClose={this.onClose}/>
                                          </div>
                                      </div>
                                  } description={
                                      <div>
                                          <Divider/>
                                          <Descriptions size="small">
                                              <Descriptions.Item label="Orden">{item.order}</Descriptions.Item>
                                              <Descriptions.Item label="Pin">{item.keyPin}</Descriptions.Item>
                                              <Descriptions.Item
                                                  label="Ícono">{item.configuration.icon}</Descriptions.Item>
                                              <Descriptions.Item
                                                  label="Pulsación">{item.configuration.pinPulseTime ? item.configuration.pinPulseTime : '-'}</Descriptions.Item>
                                              <Descriptions.Item label="Habilitado">{item.enabled ?
                                                  <CheckCircleOutlined/> : <CloseCircleOutlined/>}</Descriptions.Item>
                                          </Descriptions>
                                          <Button className="preview" type={item.configuration.type}
                                                  icon={item.configuration.icon}>
                                              {item.name}
                                          </Button>
                                      </div>
                                  }>
                                  </Card.Meta>
                              </Card>
                          </List.Item>
                      )}
                />
            </div>
        </div>
    }
}

export default Actions;


// WEBPACK FOOTER //
// ./src/app/views/actions/Actions.js